import axios from "axios";
import tools from "@/utils/tools";
import {
	AccessUrl
} from "./http.js";
import {
	MessageBox,
	Message,
} from 'element-ui'

export default function request({
	type = "COMMOn",
	data
}) {
	const service = axios.create({
		timeout: 6000*30
	});
	// 请求拦截器
	service.interceptors.request.use(
		config => {
			//发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
			config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
			config.headers = {
				"Content-Type": "application/json;charset=utf-8" //配置请求头
			};
			// 获取缓存中的token
			let token = tools.getStore('token')
			if (token) {
				config.headers.Authorization = token; //如果要求携带在请求头中
			}
			return config;
		},
		error => {
			Promise.reject(error);
		}
	);
	// 响应拦截器
	service.interceptors.response.use(response => {
			if (response.data.code == 500) {
				Message({
					message: response.data.msg,
					type: 'error',
					offset: '500'
				});
				return Promise.reject(response.data.msg)
			}
			//登录过期
			if (response.data.code == 403||response.data.code == 401) {
				Message({
					message: '登录已过期,请重新登录',
					type: 'error',
					offset: '500'
				});
				// 删除缓存中的token
				window.localStorage.removeItem('token');
				// 回退到登录页
				window.location.href = '/'
				return
			}
			// 请求成功
			if (response.data.code == 0) {
				return response.data;
			}
			// 请求不成功，抛错
			if (response.data.code != 0) {
				Message({
					message: response.data.msg,
					type: 'error',
					offset: '500'
				});
				return Promise.reject(response.data.msg)
			}
		}),
		error => {
			Message.error(error.message);
			return Promise.reject(error.response);
		};
	return service(data);
}
